module.exports = __webpack_public_path__ + "img/logo_light.aa76689c.png";